export default "__VITE_ASSET__95a4a6f2__"